var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sender-bubble"},[_c('ar-text',{style:({
      color: 'black',
    }),attrs:{"size":"sm","text":_vm.text,"allow-html":"","multiple-lines":"","line-height":"24px"},on:{"anchorClick":_vm.handlePreviewAnchorClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }